import { AlertToast, AlertTriangle, CheckCircle } from '@v2/ui';
import { toast, ToastOptions } from 'react-hot-toast';

const options: ToastOptions = {
  position: 'top-right',
};

export const errorToast = (message: string) => {
  toast.error(message, options);
};

export const successToast = (message: string) => {
  toast.success(message, options);
};

export const showToast = ({
  title = 'Oops, something went wrong',
  message = 'Please try again in a minute.',
  variant,
}: {
  title?: string;
  message?: string;
  variant: 'error' | 'success';
}) => {
  return toast.custom(
    (t) => (
      <AlertToast
        {...t}
        title={title}
        content={message}
        icon={variant === 'success' ? <CheckCircle /> : <AlertTriangle />}
      />
    ),
    { position: 'top-right' }
  );
};
